// extracted by css-extract-rspack-plugin
export default {"card":"card--dPLpekVB34s0dYdI","cardTitle":"card-title--YhSGx74Md08OXJeq"};